import { render, staticRenderFns } from "./CMSPages.vue?vue&type=template&id=54ee6cb6"
import script from "./CMSPages.vue?vue&type=script&lang=js"
export * from "./CMSPages.vue?vue&type=script&lang=js"
import style0 from "./CMSPages.vue?vue&type=style&index=0&id=54ee6cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports